import { useEffect, useState } from 'react';
import configJson from '../config/config.json';
import users from '../actions/users';
import appConfig from '../config';
import h from '../helpers/common';
import { AlertDialog } from '@intigral/ui/components/AlertDialog';
const RefreshTokenErrorDialog = () => {
    const { i18n } = configJson;
    const lang = i18n[h.getLang()] || i18n['en'];
    const appData = h.getAppData();
    const [refreshTokenErrorCode, setRefreshTokenErrorCode] = useState(null);

    useEffect(() => {
        const handleRefreshTokenError = (err) => {
            setRefreshTokenErrorCode(err?.detail?.code ?? null);
        };

        window.addEventListener('REFRESH_TOKEN_ERROR', handleRefreshTokenError);

        // Cleanup function
        return () => {
            window.removeEventListener('REFRESH_TOKEN_ERROR', handleRefreshTokenError);
        };
    }, []);

    return !!refreshTokenErrorCode || appData.refreshTokenError ? (
        <AlertDialog
            open={true}
            title={lang['managed_authintecation_refresh_token_error'].replace(
                '{ErrorCode}',
                refreshTokenErrorCode || appData?.code || 'REFRESH_TOKEN_ERROR'
            )}
            description={lang['managed_authintecation_refresh_token_attempts']
                .replace('{currentRefreshTokenAttempts}', users.currentRefreshTokenAttempts(1))
                .replace('{refreshTokenMaxAttempts}', appConfig.refreshTokenMaxAttempts)}
            acceptButton={lang['managed_authintecation_retry_btn']}
            cancelButton={lang['managed_authintecation_logout_btn']}
            onConfirm={() => {
                window.location.reload();
            }}
            onCancel={() => {
                users.logoutUser();
            }}
        />
    ) : (
        <></>
    );
};

export default RefreshTokenErrorDialog;
